<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12">
                <h2 class="page-title">Configurações de Entidades</h2>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">

            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>
                            {{ item?.Description || 'Configuração sem descrição' }}
                            <ion-badge *ngIf="item?.Type" [color]="item?.Status ? 'success' : 'medium'">
                                {{ item?.Type?.Name }}
                            </ion-badge>
                        </ion-card-title>
                        <ion-card-subtitle *ngIf="item?.Project">
                            Projeto: {{ item?.Project?.Name }}
                        </ion-card-subtitle>
                        <ion-card-subtitle *ngIf="item?.Platform">
                            Plataforma: {{ item?.Platform?.Name }}
                        </ion-card-subtitle>
                    </ion-card-header>

                    <ion-card-content>
                        <!-- Informações Básicas -->
                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="information-circle-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">ID</span>
                                    <span class="detail-value">{{ item?.Id }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Criado em</span>
                                    <span class="detail-value">{{ item?.CreateDate | date:'medium' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="person-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Criado por</span>
                                    <span class="detail-value">{{ item?.CreateUser }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid" *ngIf="item?.UpdateDate">
                            <div class="detail-item">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Atualizado em</span>
                                    <span class="detail-value">{{ item?.UpdateDate | date:'medium' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="person-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Atualizado por</span>
                                    <span class="detail-value">{{ item?.UpdateUser }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações de URL e Endpoints -->
                        <ion-item-divider *ngIf="item?.Url || item?.Project?.EndPoint">
                            <ion-label>URL e Endpoints</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid single-col" *ngIf="item?.Url">
                            <div class="detail-item">
                                <ion-icon name="link-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">URL</span>
                                    <span class="detail-value">{{ item?.Url }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col" *ngIf="item?.Project?.EndPoint">
                            <div class="detail-item">
                                <ion-icon name="server-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Endpoint</span>
                                    <span class="detail-value">{{ item?.Project?.EndPoint }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações de Autenticação -->
                        <ion-item-divider
                            *ngIf="item?.ClientId || item?.ClientSecret || item?.Token || item?.Licensekey || item?.Password">
                            <ion-label>Autenticação</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid single-col" *ngIf="item?.ClientId">
                            <div class="detail-item">
                                <ion-icon name="key-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Client ID</span>
                                    <span class="detail-value">{{ item?.ClientId }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col" *ngIf="item?.ClientSecret">
                            <div class="detail-item">
                                <ion-icon name="lock-closed-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Client Secret</span>
                                    <span class="detail-value">
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small" (click)="toggleSecretVisibility(item)">
                                            <ion-icon
                                                [name]="item.showSecret ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showSecret">{{ item?.ClientSecret }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col" *ngIf="item?.Token">
                            <div class="detail-item">
                                <ion-icon name="shield-checkmark-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Token</span>
                                    <span class="detail-value">
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small" (click)="toggleTokenVisibility(item)">
                                            <ion-icon
                                                [name]="item.showToken ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showToken">{{ item?.Token }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col" *ngIf="item?.Account">
                            <div class="detail-item">
                                <ion-icon name="person-circle-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Conta</span>
                                    <div class="account-info" [innerHTML]="formatAccountInfo(item?.Account)"></div>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col" *ngIf="item?.Licensekey">
                            <div class="detail-item">
                                <ion-icon name="document-text-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">License Key</span>
                                    <span class="detail-value">
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small" (click)="toggleLicenseVisibility(item)">
                                            <ion-icon
                                                [name]="item.showLicense ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showLicense">{{ item?.Licensekey }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col" *ngIf="item?.Password">
                            <div class="detail-item">
                                <ion-icon name="lock-closed-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Password</span>
                                    <span class="detail-value">
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small" (click)="togglePasswordVisibility(item)">
                                            <ion-icon
                                                [name]="item.showPassword ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showPassword">{{ item?.Password }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Outras Configurações -->
                        <ion-item-divider
                            *ngIf="item?.Scopes || item?.Priority || item?.ReceptionChannel">
                            <ion-label>Outras Configurações</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid single-col" *ngIf="item?.Scopes">
                            <div class="detail-item">
                                <ion-icon name="list-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Scopes</span>
                                    <span class="detail-value">{{ item?.Scopes }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid" *ngIf="item?.Priority || item?.ReceptionChannel">
                            <div class="detail-item" *ngIf="item?.Priority">
                                <ion-icon name="flag-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Prioridade</span>
                                    <span class="detail-value">{{ item?.Priority }}</span>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="item?.ReceptionChannel">
                                <ion-icon name="mail-open-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Canal de Receção</span>
                                    <span class="detail-value">{{ item?.ReceptionChannel }}</span>
                                </div>
                            </div>
                        </div>
                    </ion-card-content>
                </ion-card>
            </ion-col>

        </ion-row>
    </ion-grid>
</ion-col>
